import { FiEmptyListModule } from '@fi-shared/fi-empty-list/fi-empty-list.module';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AddQuickSelectionDialogComponentComponent } from '@fi-shared/add-quick-selection-dialog-component/add-quick-selection-dialog-component.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewsFeedItemComponent } from './news-feed-item/news-feed-item.component';
import { NewsFeedDummy } from './news-feed.model';
import { UtilitiesModule } from '../utilities/utilities.module';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';

import { NewsFeedItemHeaderComponent } from './news-feed-item-header/news-feed-item-header.component';
import { NewsFeedItemHeaderChecklistComponent } from './news-feed-item-header/news-feed-item-header-checklist/news-feed-item-header-checklist.component';
import { NewsFeedItemHeaderMediaBankComponent } from './news-feed-item-header/news-feed-item-header-media-bank/news-feed-item-header-media-bank.component';
import { NewsFeedItemHeaderPostComponent } from './news-feed-item-header/news-feed-item-header-post/news-feed-item-header-post.component';
import { NewsFeedItemHeaderDocumentComponent } from './news-feed-item-header/news-feed-item-header-document/news-feed-item-header-document.component';
import { NewsFeedItemContentComponent } from './news-feed-item-content/news-feed-item-content.component';
import { NewsFeedItemContentPostComponent } from './news-feed-item-content/news-feed-item-content-post/news-feed-item-content-post.component';
import { NewsFeedItemContentDocumentComponent } from './news-feed-item-content/news-feed-item-content-document/news-feed-item-content-document.component';
import { NewsFeedItemContentChecklistComponent } from './news-feed-item-content/news-feed-item-content-checklist/news-feed-item-content-checklist.component';
import { NewsFeedItemContentMediaBankComponent } from './news-feed-item-content/news-feed-item-content-media-bank/news-feed-item-content-media-bank.component';
import { NewsFeedItemEditComponent } from './news-feed-item-edit/news-feed-item-edit.component';
import { NewsFeedComponent } from './news-feed/news-feed.component';
import { LargePostBubbleComponent } from './large-post-bubble/large-post-bubble.component';
import { MatIconModule } from '@angular/material/icon';
import { NewsFeedService } from './news-feed.service';
import { NewsFeedItemSingleViewComponent } from './news-feed-item-single-view/news-feed-item-single-view.component';
import { NewsFeedItemMenuComponent } from './news-feed-item-menu/news-feed-item-menu.component';
import { FiLikesModule } from '@fi-app/shared/ccm-likes/likes.module';
import { FiNewsFeedEditMobileModule } from './edit-mobile/edit-mobile.module';
import { NewsFeedModuleService } from './news-feed-module.service';
import { FiNewsFeedAddPostMobileComponent } from './news-feed-add-post-mobile/news-feed-add-post-mobile.component';
import { FiMediaViewerModule } from '@fi-shared/media-viewer/media-viewer.module';
import { FiCommentLikeButtonsModule } from '@fi-shared/fi-comments/fi-comment-like-buttons/fi-comment-like-buttons.module';
import { NewsFeedItemContentFormComponent } from './news-feed-item-content/news-feed-item-content-form/news-feed-item-content-form.component';
import { NewsFeedItemHeaderFormComponent } from './news-feed-item-header/news-feed-item-header-form/news-feed-item-header-form.component';
import { NewsFeedItemContentFormReminderComponent } from './news-feed-item-content/news-feed-item-content-form-reminder/news-feed-item-content-form-reminder.component';
import { NewsFeedItemHeaderFormReminderComponent } from './news-feed-item-header/news-feed-item-header-form-reminder/news-feed-item-header-form-reminder.component';
import { FiVimeoModule } from '@fi-shared/media-bank/fi-vimeo/fi-vimeo.module';
import { NewsFeedItemHeaderTaskReminderComponent } from '@fi-app/news-feed/news-feed-item-header/news-feed-item-header-task-reminder/news-feed-item-header-task-reminder.component';
import { NewsFeedItemContentTaskReminderComponent } from '@fi-app/news-feed/news-feed-item-content/news-feed-item-content-task-reminder/news-feed-item-content-task-reminder.component';
import { FiBtnUploadFileModule } from '@fi-shared/fi-insert-media/btn-upload-file/btn-upload-file.module';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FiNewsFeedSharedModule } from '@fi-shared/fi-news-feed-shared/fi-news-feed-shared.module';
import { FiReadsCountButtonModule } from '@fi-shared/fi-news-feed-shared/fi-news-feed-buttons/fi-reads-count-button/fi-reads-count-button.module';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { FiInsertMediaModule } from '@fi-shared/fi-insert-media/fi-insert-media.module';
import { FiSiteDesignModule } from '@fi-app/fi-site-design/fi-site-design.module';
import { NewsFeedItemHeaderPkComponent } from './news-feed-item-header/news-feed-item-header-pk/news-feed-item-header-pk.component';
import { NewsFeedItemContentPkComponent } from './news-feed-item-content/news-feed-item-content-pk/news-feed-item-content-pk.component';
import { NewsFeedItemContentBalooComponent } from './news-feed-item-content/news-feed-item-content-baloo/news-feed-item-content-baloo.component';
import { NewsFeedItemHeaderBalooComponent } from './news-feed-item-header/news-feed-item-header-baloo/news-feed-item-header-baloo.component';
import { FiTextEditorModule } from '@fi-shared/text-editor/text-editor.module';

@NgModule({
    imports: [
        CommonModule,
        UtilitiesModule,
        MatCardModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        FiLikesModule,
        FiTextEditorModule,
        FiNewsFeedEditMobileModule,
        FiMediaViewerModule,
        FiCommentLikeButtonsModule,
        FiBtnUploadFileModule,
        MatCheckboxModule,
        FormsModule,
        FiEmptyListModule,
        FiVimeoModule,
        FiProfileIconModule,
        FiNewsFeedSharedModule,
        FiReadsCountButtonModule,
        FiAttachmentsModule,
        FiInsertMediaModule,
        FiSiteDesignModule,
    ],
    declarations: [
        NewsFeedItemComponent,
        NewsFeedItemHeaderComponent,
        NewsFeedItemHeaderChecklistComponent,
        NewsFeedItemHeaderMediaBankComponent,
        NewsFeedItemHeaderPostComponent,
        NewsFeedItemHeaderDocumentComponent,
        NewsFeedItemHeaderFormComponent,
        NewsFeedItemContentComponent,
        NewsFeedItemContentPostComponent,
        NewsFeedItemContentDocumentComponent,
        NewsFeedItemContentChecklistComponent,
        NewsFeedItemContentMediaBankComponent,
        NewsFeedItemContentFormComponent,
        NewsFeedItemEditComponent,
        NewsFeedComponent,
        LargePostBubbleComponent,
        NewsFeedItemSingleViewComponent,
        NewsFeedItemMenuComponent,
        FiNewsFeedAddPostMobileComponent,
        AddQuickSelectionDialogComponentComponent,
        NewsFeedItemContentFormReminderComponent,
        NewsFeedItemHeaderFormReminderComponent,
        NewsFeedItemContentTaskReminderComponent,
        NewsFeedItemHeaderTaskReminderComponent,
        NewsFeedItemHeaderPkComponent,
        NewsFeedItemContentPkComponent,
        NewsFeedItemContentBalooComponent,
        NewsFeedItemHeaderBalooComponent,
    ],
    exports: [NewsFeedComponent],
    providers: [NewsFeedDummy, NewsFeedModuleService, NewsFeedService],
})
export class NewsFeedModule {}
